import LoanCardReportActionTypes from './loan-card-report.types';

/** ***************** GET PARTICULAR MEMBER LOAN CARD START *********************** */
export const getMemberLoanCardStart = (getData: any) => ({
	type: LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_START,
	payload: getData,
});

export const getMemberLoanCardSuccess = (successData: any) => ({
	type: LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_SUCCESS,
	payload: successData,
});

export const getMemberLoanCardFailure = (failureData: any) => ({
	type: LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_FAILURE,
	payload: failureData,
});

export const getMemberLoanCardResponseResetStart = () => ({
	type: LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_RESPONSE_RESET,
});

export const getMemberLoanCardResponseChanged = () => ({
	type: LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_RESPONSE_CHANGED,
});
/** ***************** GET PARTICULAR MEMBER LOAN CARD END *********************** */
